import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getMyProfile } from '@/api/profile';
import useAuthStore from '@/stores/authStore';

export const useUserProfile = () => {
  const accessToken = useAuthStore((state) => state.accessToken);
  const setUser = useAuthStore((state) => state.setUser);

  const query = useQuery({
    queryKey: ['user-profile'],
    queryFn: getMyProfile,
    enabled: !!accessToken,
    staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
    cacheTime: 30 * 60 * 1000, // Keep data in cache for 30 minutes
  });

  useEffect(() => {
    if (query.data) {
      setUser(query.data.data);
    }
    if (query.error) {
      // setUser(null);
    }
  }, [query.data, query.error, setUser]);

  return query;
}; 